module.exports = "/images/ReviewVertical_G.png?6358994fecf35486133d5cad8926b2cb";